import * as z from 'zod';

export const emailMetadataSchema = z.object({
  from: z.string().optional(),
  to: z.array(z.string()).optional(),
  template_variables: z.record(z.string(), z.string()).optional(),
});

export type EmailMetadataSchema = z.infer<typeof emailMetadataSchema>;

export const deliveryDetailsHeadersSchema = z.object({
  'Message-ID': z.string().optional(),
  From: z.string().optional(),
  To: z.string().optional(),
  Date: z.string().optional(),
});

export type DeliveryDetailsHeadersSchema = z.infer<typeof deliveryDetailsHeadersSchema>;

export const deliveryDetailsSchema = z.object({
  provider: z.string().optional(),
  message_id: z.string().optional(),
  graph_message_id: z.string().optional(),
  web_link: z.string().optional(),
  attachments: z.array(z.number()).optional(),
  headers: deliveryDetailsHeadersSchema.optional(),
  trace_status: z.string().optional(),
  reconciled_at: z.string().optional(),
  accepted_at: z.string().optional(),
  mailbox: z.string().optional(),
});

export type DeliveryDetailsSchema = z.infer<typeof deliveryDetailsSchema>;

export function parseJsonField<T>(raw: unknown): T | null {
  if (raw == null) {
    return null;
  }

  if (typeof raw === 'object') {
    return raw as T;
  }

  if (typeof raw !== 'string') {
    return null;
  }

  if (!raw.trim()) {
    return null;
  }

  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}
